export const findElementNameByKey = (elementsByMediaType, key) =>
    elementsByMediaType?.find((el) => el.key === key)?.name ?? "";
